var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6168 8.86911L18.6106 8.86638L1.92774 1.94685C1.78741 1.88812 1.63472 1.86509 1.48332 1.87981C1.33192 1.89453 1.18653 1.94656 1.06016 2.03123C0.926639 2.11871 0.816966 2.23802 0.741006 2.37842C0.665046 2.51882 0.625182 2.67589 0.625 2.83552V7.26091C0.625074 7.47913 0.701273 7.69049 0.840463 7.85856C0.979653 8.02663 1.17311 8.14088 1.3875 8.18161L10.4863 9.86403C10.5221 9.87081 10.5544 9.88986 10.5776 9.91788C10.6008 9.94591 10.6135 9.98116 10.6135 10.0175C10.6135 10.0539 10.6008 10.0892 10.5776 10.1172C10.5544 10.1452 10.5221 10.1643 10.4863 10.1711L1.38789 11.8535C1.17356 11.8941 0.980115 12.0082 0.840862 12.1761C0.70161 12.344 0.625273 12.5553 0.625 12.7734V17.1996C0.624896 17.352 0.662638 17.5021 0.734839 17.6363C0.80704 17.7706 0.911441 17.8848 1.03867 17.9687C1.19172 18.0704 1.37133 18.1247 1.55508 18.125C1.68282 18.1249 1.80925 18.0992 1.92695 18.0496L18.6094 11.1695L18.6168 11.166C18.8414 11.0695 19.0327 10.9093 19.1672 10.7051C19.3016 10.501 19.3733 10.262 19.3733 10.0175C19.3733 9.77313 19.3016 9.53408 19.1672 9.32996C19.0327 9.12584 18.8414 8.96562 18.6168 8.86911Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7e448efc9026b21384431b60ab395845.svg";
export { ForwardRef as ReactComponent };